var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.imgStyle)},[(_vm.cover)?_c('div',{style:(_vm.coverStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }